export default {
  apartmentId: (state) => state.apartment.id,
  createWizardData: (state) => state.createWizard.rawData || {},
  createWizardPageData:
    (state) => (params) => state.createWizard.wizardData[params.page][params.key],
  apartmentSettingsKey: (state) => state.apartment.settingsKey,
  detailViewLoader: (state) => state.detailView.loading,
  getParentRoute: (state) => state.parentRouteName,
};
